import React, { useState } from "react";
import { Button } from "./Button";
import { api } from "./helpers";
import { Input } from "./Input";
import { Some } from "./helpers/option";

declare global {
    // eslint-disable-next-line no-unused-vars
    interface Window {
        dataLayer: any;
    }
}
export function AccountSettings({ token, handleToast, setUser }) {
    const [accountDetails, setDetails] = useState({
        full_name: "",
        display_name: ""
    });

    const handleSaveSettings = async () => {
        const resp = await api.save_settings(token, accountDetails.full_name, accountDetails.display_name);
        if (resp.error) {
            return handleToast({
                error: resp.error,
                error_message: resp.error_message
            });
        }
        handleToast({
            title: "Successfully saved account details."
        });
        setUser(new Some(resp.data.user));
        // router.push(`/${PLATFORM_ROUTE}/auth/create_group`, undefined, { shallow: true });
    };

    return <>
        <div className="form-container">
            <h2>Account details</h2>
            <Input label="Full Name" fill onChange={(e) => {
                setDetails({ ...accountDetails, ...{ full_name: e.target.value } });
            }} />
            <Input label="Display Name" fill onChange={(e) => {
                setDetails({ ...accountDetails, ...{ display_name: e.target.value } });
            }} />
            <Button disabled={accountDetails.display_name.length === 0 || accountDetails.full_name.length === 0} onClick={handleSaveSettings}>Continue</Button>
        </div>
        <style jsx>
            {`
            h2{
                font-size: var(--font-size-6);
                line-height: var(--line-height-6);

            }
            .button-group{
                display:flex;
                flex-direction:column;
                gap:1rem;
            }
            .button-group-row{
                display:flex;
                gap:1rem;
                width:100%;
            }
            
            .re-send{
                color:var(--pink);
            }
            .re-send:hover{
                cursor: pointer;
            }
            .form-container{
                display:flex;
                flex-direction: column;
                gap:2rem;
                max-width:40rem;
                min-width:20rem;
            }
            .highlight{
                color: var(--pink);
            }

            `}
        </style>
    </>;
}
